import React from "react";
import { Link } from "react-router-dom";

const NewHeroSection = () => {
  return (
    <div className="relative w-full h-[600px] md:h-[700px] lg:h-[800px] flex flex-col justify-center items-center overflow-hidden">
      {/* Background with multiple gradient overlays to match the dark brown aesthetic */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#2A1D13] via-[#3B291A] to-[#25150E] z-0"></div>
      
      {/* Decorative background image overlay */}
      <div 
        className="absolute inset-0 z-0 opacity-40 mix-blend-overlay"
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1599643478524-fb66f70d00f8?auto=format&fit=crop&q=80')",
          backgroundSize: "cover",
          backgroundPosition: "center"
        }}
      ></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center flex flex-col items-center justify-center mt-10 md:mt-20">
        <p className="text-sm md:text-base text-[#D4AF37] uppercase tracking-widest mb-4 font-semibold font-serif">
          Auro: Where every piece is a masterpiece...
        </p>
        
        <h1 className="text-4xl md:text-6xl lg:text-7xl text-white font-serif mb-6 leading-tight max-w-4xl mx-auto">
          Heritage Crafted in <br className="hidden md:block" />
          <span className="text-[#D4AF37]">Precious Metals</span>
        </h1>
        
        <p className="text-gray-300 text-sm md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          From classic designs to contemporary marvels, each creation showcases 
          the brilliance of precious metals and meticulous craftsmanship.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center w-full sm:w-auto">
          <Link to="/shop" className="bg-[#D4AF37] hover:bg-[#B8982D] text-black font-semibold py-3 px-8 transitionduration-300 text-center uppercase tracking-wide text-sm border-2 border-[#D4AF37]">
            Shop Now
          </Link>
          <Link to="/contact" className="bg-transparent hover:bg-white/10 text-white font-semibold py-3 px-8 transitionduration-300 text-center uppercase tracking-wide text-sm border-2 border-white/30 backdrop-blur-sm">
            Contact Us
          </Link>
        </div>
      </div>

      {/* Bottom Stats Bar */}
      <div className="absolute bottom-0 w-full bg-[#D4AF37] z-20 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 py-3 md:py-4">
          <div className="flex justify-between items-center text-black font-semibold text-xs md:text-sm lg:text-base gap-4 text-center px-4 overflow-x-auto whitespace-nowrap hide-scrollbar">
            <div className="flex-1 px-4 cursor-default">
              <span className="font-bold">3K+</span> Happy Customers
            </div>
            <div className="hidden md:block h-5 w-px bg-black/20"></div>
            <div className="flex-1 px-4 cursor-default">
              <span className="font-bold">20+</span> Offline Stores
            </div>
            <div className="hidden md:block h-5 w-px bg-black/20"></div>
            <div className="flex-1 px-4 cursor-default">
              <span className="font-bold">50+</span> Global presence
            </div>
            <div className="hidden md:block h-5 w-px bg-black/20"></div>
            <div className="flex-1 px-4 cursor-default">
              <span className="font-bold">29+</span> Years in Business
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  );
};

export default NewHeroSection;
